import { createAction, props } from "@ngrx/store";
import { ISkillNode, IAddSkillNodeRequest } from "@skills-app/models/skillNode";
import { SortParameters } from "@skills-app/models/sorting";

const prefix = "[Skills Page]";

export const loadPage = createAction(`${prefix} Load Page`);
export const selectSkill = createAction(
  `${prefix} Select Skill`,
  props<{ skill: ISkillNode }>(),
);
export const requestAddSkill = createAction(
  `${prefix} Request Add Skill`,
  props<{ addSkillRequest: IAddSkillNodeRequest }>(),
);

export const requestForceAddSkill = createAction(
  `${prefix} Request Force Add Skill`,
  props<{ addSkillRequest: IAddSkillNodeRequest }>(),
);

export const toggleFilteredByRelatedSkillsThreshold = createAction(
  `${prefix} Toggle Filtered By Related Skills Threshold`,
  props<{ relatedSkillsThreshold: number }>(),
);
export const clearSelectedSkill = createAction(
  `${prefix} Clear Selected Skill`,
);
export const updateSort = createAction(
  `${prefix} Update SkillNode Sort`,
  props<{ value: SortParameters }>(),
);
export const setOnlyRecentSkillNodes = createAction(
  `${prefix} Limit Skill Nodes to last 3 months`,
  props<{ value: boolean }>(),
);
